import "./ExcelStepIndicator.css";

const STEPS = [
  { number: 1, label: "Selecteer" },
  { number: 2, label: "Upload" },
  { number: 3, label: "Controleer" },
  { number: 4, label: "Rapport" },
];

export default function ExcelStepIndicator({ currentStep = 1 }) {
  return (
    <div className="excel-step-indicator">
      {STEPS.map((step) => (
        <div
          key={step.number}
          className={`excel-step-indicator__item ${
            currentStep >= step.number
              ? "excel-step-indicator__item--active"
              : ""
          }`}
        >
          <span>{step.number}</span>
          <strong>{step.label}</strong>
        </div>
      ))}
    </div>
  );
}
